<template>
  <div class="HeaderInfoTitle">
    <!-- <div class="HeaderInfoTitle-title">患者档案</div> -->
    <div class="HeaderInfoTitle-btn">
      <a-button type="primary" danger @click="handleOpenTodo" v-show="patientType">
        近期待办
        <div class="todo-number">
          {{ Number(totalTodoNum) > 99 ? '99+' : totalTodoNum }}
        </div>
      </a-button>
      <a-button @click="handleOpenMatch" type="primary">匹配关联已有用户</a-button>
    </div>
    <!--    近期待办 弹框-->
    <TodoModal ref="todoModalRef" />
    <!--    匹配关联已有用户 弹框-->
    <PatientMatchModal ref="matchModalRef" />
  </div>
</template>

<script setup>
import PatientMatchModal from './PatientMatchModal.vue'
import { computed, ref, onMounted } from 'vue'
import TodoModal from '@/components/PatientFile/ModalBody/todo/TodoModal.vue'
import { useStore } from 'vuex'

const info = computed(() => store.state.patientFile.info)
const todoModalRef = ref(null)
const matchModalRef = ref(null)
const store = useStore()
const totalTodoNum = computed(() => store.getters.totalTodoNum)
const patientType = computed(() => store.state.patientFile.patientType)

const handleOpenTodo = () => {
  todoModalRef.value?.openMatch()
}
const handleOpenMatch = () => {
  matchModalRef.value?.openMatch()
}

// 组件加载时获取近期待办数据
onMounted(() => {
  if (patientType.value) {
    store.dispatch('patientFile/getSummaryTodoAll', {
      ucPatientId: info.value.ucPatientId
    })
  }
})
</script>

<style lang="scss" scoped>
.HeaderInfoTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &-title {
    font-weight: 500;
    font-size: 16px;
    color: #000000d9;
  }
  &-btn {
    display: flex;
    align-items: center;
    .todo-number {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px;
      height: 18px;
      min-width: 18px;
      border-radius: 9px;
      background: #ffffff;
      font-weight: 500;
      font-size: 14px;
      color: #f84f4f;
      margin-left: 6px;
    }
    button:first-child {
      display: flex;
      align-items: center;
      margin-right: 24px;

      // 覆盖 ant-design-vue 的 danger 按钮聚焦和激活状态样式
      &:focus,
      &:active {
        background-color: #f84f4f !important;
        border-color: #f84f4f !important;
        color: #fff !important;
        box-shadow: none !important;
      }
    }
  }
}
</style>
